<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="告警列表">
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="编码">
              <a-input  v-model="searchP.keyword"  placeholder="appcode或系统编码" ></a-input>
          </a-form-item>
          <a-form-item label="服务地址">
              <a-input  v-model="searchP.serviceurl"  placeholder="请输入服务地址" ></a-input>
          </a-form-item>
          <a-form-item label="处理状态">
                <a-select v-model="searchP.dealstatus"  placeholder="" style="width:100px;">
                    <a-select-option value="">
                    全部
                    </a-select-option>
                    <a-select-option value="0">
                    未处理
                    </a-select-option>
                    <a-select-option value="1">
                    处理中
                    </a-select-option>
                    <a-select-option value="2">
                    已处理
                    </a-select-option>
                </a-select>
          </a-form-item>
          <a-form-item label="告警类型">
                <a-select v-model="searchP.alerttype"  placeholder="" style="width:100px;">
                    <a-select-option value="">
                    全部
                    </a-select-option>
                    <a-select-option value="1">
                    异常告警
                    </a-select-option>
                    <a-select-option value="2">
                    失败率告警
                    </a-select-option>
                    <a-select-option value="3">
                    超时告警
                    </a-select-option>
                </a-select>
          </a-form-item>
         <a-form-model-item  label="开始日期" prop="starttime">
            <a-date-picker v-model="searchP.starttime" format="YYYY-MM-DD" />
         </a-form-model-item>
         <a-form-model-item  label="结束日期" prop="endtime">
            <a-date-picker  v-model="searchP.endtime"   format="YYYY-MM-DD" />
         </a-form-model-item>
          <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 告警列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
        <span slot="authflag" slot-scope="text">{{flagname[text]}}</span>
    
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
            <span> 
                <a-popover :title="record.dashboardurl">
                    <a type="link" @click="handle_auth_load(record)" >查看</a>
                </a-popover>
          </span>
           <span> 
                <router-link  :to="{ path:'edit', query: { id: record.id ,serviceurl: record.serviceurl ,alerttype: record.alerttype }}"
                >编辑
                </router-link>
          </span>
        </div>
      </template>

    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },{
        title: "系统编码",
        dataIndex: "syscode",
        width:120
    },
    {
        title: "应用编码",
        dataIndex: "appcode",
        width:120
    },
    {
        title: "预警项",
        dataIndex: "title",
        width:150
    },
    
    {
        title: "总数",
        dataIndex: "exceptionnum",
        width:60
    },
    {
        title: "成功数",
        dataIndex: "successnumber", 
        width:80
    },
    {
        title: "失败数",
        dataIndex: "failumber", 
        width:80
    },
    {
        title: "失败率(%)",
        dataIndex: "failrate",
        width:100
    },
    {
        title: "最大时间",
        dataIndex: "toptime",
        width:100
    },

    {
        title: "通知责任人",
        dataIndex: "notifyusers",
        width:150
    },
    {
        title: "处理状态",
        dataIndex: "dealstatus",
        width:120
    },
    // {
    //     title: "处理说明",
    //     dataIndex: "dealdesc",
    //     width:150
    // },
    {
        title: "通知时间",
        dataIndex: "firetime",
        width:150
    },
    {
        title: "错误码",
        dataIndex: "exceptioncode",
        width:150
    },
    {
        title: "中仑服务地址",
        dataIndex: "serviceurl",
        width:150
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        };
    },
    methods: {

        handlePageChange(c_p){
            this.getAlarmList(c_p)
        },
        getAlarmList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.endtime = c_params.endtime ?  this.dateFormat('YYYY-mm-dd',new Date(c_params.endtime)) : '';
            c_params.starttime =c_params.starttime ? this.dateFormat('YYYY-mm-dd',new Date(c_params.starttime)): '';
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmmanager/list",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        // 钉钉屏蔽跳转
        blockJump(query){
            let c_params =  query;
            c_params.page =1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmmanager/list",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        handle_auth_load(ritem){
            window.open(ritem.dashboardurl);
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "alarmmanager/getEmptySearch",
                showMsg: true
            })
            this.$refs.shopcodeAs.setInputVal(this.searchP.shopcode);
        },

        handleSubmit(e){
            e.preventDefault();
            this.getAlarmList(1)
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

    },
    computed:{
        ...mapState('alarmmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        const { query } = this.$route;
        this.blockJump(query);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
